import { lazy } from 'react'
import { LANG } from "../language/lang";

import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';
import SportsEsportsOutlinedIcon from '@mui/icons-material/SportsEsportsOutlined';
import MoneyOutlinedIcon from '@mui/icons-material/MoneyOutlined';
import RedeemOutlinedIcon from '@mui/icons-material/RedeemOutlined';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import AnalyticsOutlinedIcon from '@mui/icons-material/AnalyticsOutlined';
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import ApiOutlinedIcon from '@mui/icons-material/ApiOutlined';


import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import MonitorOutlinedIcon from '@mui/icons-material/MonitorOutlined';
import GiteOutlinedIcon from '@mui/icons-material/GiteOutlined';
import StayCurrentPortraitOutlinedIcon from '@mui/icons-material/StayCurrentPortraitOutlined';

const PublicLayout = lazy(() => import('../layouts/PublicLayout'))
const AuthLayout = lazy(() => import('../layouts/AuthLayout'))
const PanelLayout = lazy(() => import('../layouts/PanelLayout'))
const ProtectedRoute = lazy(() => import('../routers/ProtectedRoute'))

const Home = lazy(() => import('../pages/Home'))
const Login = lazy(() => import('../pages/Auth/Login'))
const Dashboard = lazy(() => import('../pages/Panel/Dashboard'))
const Orders = lazy(() => import('../pages/Panel/Orders'))
const GameKey = lazy(() => import('../pages/Panel/GameKey'))
const GameCoin = lazy(() => import('../pages/Panel/GameCoin'))
const TopUp = lazy(() => import('../pages/Panel/TopUp'))
const Balance = lazy(() => import('../pages/Panel/Balance'))
const Profile = lazy(() => import('../pages/Panel/Profile'))
const Settings = lazy(() => import('../pages/Panel/Settings'))
const Analytics = lazy(() => import('../pages/Panel/Analytics'))
const Support = lazy(() => import('../pages/Panel/Support'))
const Logout = lazy(() => import('../pages/Panel/Logout'))
const Api = lazy(() => import('../pages/Panel/Api'))

const iconSize = { width: '20px', height: '20px'};

const ROUTE = [
    {
        path: '/',
        component: <PublicLayout />,
        componentName: 'PublicLayout',
        children: [
            {
                index: true,
                component: <Home />,
                menu: true,
                onlyMobile: false,
                secondary: false,
                title: LANG("MENU_HOME")
            },



        ],
    },
    {
        path: '/auth',
        componentName: 'AuthLayout',
        component: <AuthLayout />,
        children: [
            {
                path: 'login',
                component: <Login />,
            },
        ],
    },

    {
        path: '/panel',
        componentName: 'ProtectedRoute',
        component: <ProtectedRoute />,
        children: [
            {
                component: <PanelLayout />,
                path: '/panel',
                componentName: 'PanelLayout',
                children: [
                    {
                        title: LANG("SECTION_HOME"),
                        menu: true,
                        onlyMobile: false,
                    },
                    {
                        index: true,
                        component: <Dashboard />,
                        menu: true,
                        onlyMobile: false,
                        secondary: false,
                        title: LANG("MENU_HOME"),
                        icon: <HomeOutlinedIcon sx={iconSize} />,
                        pageTitle: {
                            header: LANG("PAGE_HEADER_HOME"),
                            description: LANG("PAGE_DESCRIPTION_HOME"),
                        }
                    },
                    {
                        path: 'orders',
                        component: <Orders />,
                        menu: true,
                        onlyMobile: false,
                        secondary: false,
                        icon: <ShoppingBagOutlinedIcon sx={iconSize}/>,
                        title: LANG("MENU_ORDERS"),
                        pageTitle: {
                            header: LANG("PAGE_HEADER_ORDERS"),
                            description: LANG("PAGE_DESCRIPTION_ORDERS"),
                        },
                        fastAction: {
                            title: LANG("FAST_ACTION_ORDERS"),
                            description: LANG("FAST_ACTION_ORDERS_DESCRIPTION"),
                        }
                    },
                    {
                        type: 'divider',
                        key: 0,
                        menu: true,
                        onlyMobile: false,
                    },
                    {
                        title: LANG("SECTION_PRODUCTS"),
                        menu: true,
                        onlyMobile: false,
                    },

                    {
                        path: 'ipv4',
                        component: <GameKey />,
                        menu: true,
                        onlyMobile: false,
                        secondary: false,
                        icon: <LanguageOutlinedIcon sx={iconSize}/>,
                        title: LANG("MENU_GAME_KEYS"),
                        pageTitle: {
                            header: LANG("PAGE_HEADER_GAME_KEYS"),
                            description: LANG("PAGE_DESCRIPTION_GAME_KEYS"),
                        },
                        fastAction: {
                            title: LANG("FAST_ACTION_GAME_KEYS"),
                            description: LANG("FAST_ACTION_GAME_KEYS_DESCRIPTION"),
                        }
                    },

                    {
                        path: 'ipv6',
                        component: <GameCoin />,
                        menu: true,
                        onlyMobile: false,
                        secondary: false,
                        icon: <LanguageOutlinedIcon sx={iconSize}/>,
                        title: LANG("MENU_GAME_COIN"),
                        pageTitle: {
                            header: LANG("PAGE_HEADER_GAME_COIN"),
                            description: LANG("PAGE_DESCRIPTION_GAME_COIN"),
                        },
                        fastAction: {
                            title: LANG("FAST_ACTION_GAME_COIN"),
                            description: LANG("FAST_ACTION_GAME_COIN_DESCRIPTION"),
                        }
                    },

                    {
                        path: 'isp',
                        component: <TopUp />,
                        menu: true,
                        onlyMobile: false,
                        secondary: false,
                        icon: <MonitorOutlinedIcon sx={iconSize}/>,
                        title: LANG("MENU_TOP_UP"),
                        pageTitle: {
                            header: LANG("PAGE_HEADER_TOP_UP"),
                            description: LANG("PAGE_DESCRIPTION_TOP_UP"),
                        },
                        fastAction: {
                            title: LANG("FAST_ACTION_TOP_UP"),
                            description: LANG("FAST_ACTION_TOP_UP_DESCRIPTION"),
                        }
                    },

                    {
                        path: 'residential',
                        component: <TopUp />,
                        menu: true,
                        onlyMobile: false,
                        secondary: false,
                        icon: <GiteOutlinedIcon sx={iconSize}/>,
                        title: LANG("MENU_RESIDENTIAL"),
                        pageTitle: {
                            header: LANG("PAGE_HEADER_RESIDENTIAL"),
                            description: LANG("PAGE_DESCRIPTION_RESIDENTIAL"),
                        },
                        fastAction: {
                            title: LANG("FAST_ACTION_RESIDENTIAL"),
                            description: LANG("FAST_ACTION_RESIDENTIAL_DESCRIPTION"),
                        }
                    },

                    {
                        path: 'mobile',
                        component: <TopUp />,
                        menu: true,
                        onlyMobile: false,
                        secondary: false,
                        icon: <StayCurrentPortraitOutlinedIcon sx={iconSize}/>,
                        title: LANG("MENU_MOBILE"),
                        pageTitle: {
                            header: LANG("PAGE_HEADER_MOBILE"),
                            description: LANG("PAGE_DESCRIPTION_MOBILE"),
                        },
                        fastAction: {
                            title: LANG("FAST_ACTION_MOBILE"),
                            description: LANG("FAST_ACTION_MOBILE_DESCRIPTION"),
                        }
                    },

                   
                    

                    {
                        type: 'divider',
                        key: 2,
                        menu: true,
                        onlyMobile: false,
                    },
                    {
                        title: LANG("SECTION_ACCOUNT"),
                        menu: true,
                        onlyMobile: false,
                    },

                    {
                        path: 'profile',
                        component: <Profile />,
                        menu: true,
                        onlyMobile: false,
                        secondary: false,
                        icon: <AccountCircleOutlinedIcon sx={iconSize}/>,
                        title: LANG("MENU_PROFILE"),
                        pageTitle: {
                            header: LANG("PAGE_HEADER_PROFILE"),
                            description: LANG("PAGE_DESCRIPTION_PROFILE"),
                        }
                    },

                    {
                        path: 'settings',
                        component: <Settings />,
                        menu: true,
                        onlyMobile: false,
                        secondary: false,
                        icon: <SettingsOutlinedIcon sx={iconSize}/>,
                        title: LANG("MENU_SETTINGS"),
                        pageTitle: {
                            header: LANG("PAGE_HEADER_SETTINGS"),
                            description: LANG("PAGE_DESCRIPTION_SETTINGS"),
                        }
                    },

                    {
                        path: 'analytics',
                        component: <Analytics />,
                        menu: true,
                        onlyMobile: false,
                        secondary: false,
                        icon: <AnalyticsOutlinedIcon sx={iconSize}/>,
                        title: LANG("MENU_ANALYTICS"),
                        pageTitle: {
                            header: LANG("PAGE_HEADER_NALYTICS"),
                            description: LANG("PAGE_DESCRIPTION_NALYTICS"),
                        }
                    },

                    {
                        path: 'balance',
                        component: <Balance />,
                        menu: true,
                        onlyMobile: false,
                        secondary: false,
                        icon: <AccountBalanceWalletOutlinedIcon sx={iconSize}/>,
                        title: LANG("MENU_BALANCE"),
                        pageTitle: {
                            header: LANG("PAGE_HEADER_BALANCE"),
                            description: LANG("PAGE_DESCRIPTION_BALANCE"),
                        }
                    },

                    {
                        path: 'api',
                        component: <Api />,
                        menu: true,
                        onlyMobile: false,
                        secondary: false,
                        icon: <ApiOutlinedIcon sx={iconSize}/>,
                        title: LANG("MENU_API"),
                        pageTitle: {
                            header: LANG("PAGE_HEADER_API"),
                            description: LANG("PAGE_DESCRIPTION_API"),
                        }
                    },

                    {
                        path: 'support',
                        component: <Support />,
                        menu: true,
                        onlyMobile: false,
                        secondary: false,
                        icon: <SupportAgentOutlinedIcon sx={iconSize}/>,
                        title: LANG("MENU_SUPPORT"),
                        pageTitle: {
                            header: LANG("PAGE_HEADER_SUPPORT"),
                            description: LANG("PAGE_DESCRIPTION_SUPPORT"),
                        }
                    },

                    {
                        path: 'logout',
                        component: <Logout />,
                        menu: true,
                        onlyMobile: false,
                        secondary: false,
                        icon: <LogoutOutlinedIcon sx={iconSize}/>,
                        title: LANG("MENU_LOGOUT"),
                        pageTitle: {
                            header: LANG("PAGE_HEADER_LOGOUT"),
                            description: LANG("PAGE_DESCRIPTION_LOGOUT"),
                        }
                    },

                   

                ],
            },
        ],

    }

]

export default ROUTE